import { PriceItem } from '@/features/common/components/Overview/types'
import Button from '@/features/openTabs/components/AccountActionButton'
import CollapsibleFooter from '@/features/openTabs/components/CollapsibleFooter'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface CatalogFooterProps {
    totalPrice: string
    priceItems: PriceItem[]
    canConfirm: boolean
    submitting?: boolean
    confirmLabel?: string
    onCancel: () => void
    onConfirm: () => void
}

const CatalogFooter: FC<CatalogFooterProps> = ({
    totalPrice,
    priceItems,
    canConfirm,
    submitting = false,
    confirmLabel,
    onCancel,
    onConfirm,
}) => {
    const { t } = useTranslation('app')
    const { styles } = useStyles(stylesheet)

    return (
        <CollapsibleFooter
            totalPrice={totalPrice}
            priceItems={priceItems}
            testID="open-account-catalog-footer"
        >
            <View style={styles.actions}>
                <Button
                    color="primary"
                    disabled={submitting}
                    onPress={onCancel}
                    style={styles.button}
                >
                    {t('openTabs.actions.cancel')}
                </Button>
                <Button
                    disabled={!canConfirm || submitting}
                    color="action"
                    onPress={onConfirm}
                    style={styles.button}
                >
                    {confirmLabel ?? t('openTabs.actions.sendToKitchen')}
                </Button>
            </View>
        </CollapsibleFooter>
    )
}

const stylesheet = createStyleSheet({
    actions: {
        flexDirection: 'row',
        gap: 16,
    },
    button: {
        flex: 1,
        height: 44,
        justifyContent: 'center',
        borderRadius: 8,
    },
})

export default CatalogFooter
